import React, { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import ModalHeader from 'features/shared/components/modal/ModalHeader';
import ModalFooter from 'features/shared/components/modal/ModalFooter';
import PromiseLoadingSpinner from 'features/shared/components/loaders/PromiseLoadingSpinner';
import { ContractDetail_PlaceOfDeliveryNameDialog } from 'features/shared/components/loaders/promiseLoadingAreas';
import RolesChecker from 'features/customer/components/RolesChecker';
import { useTranslation } from 'react-i18next';

interface Props {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  onSubmit: (name: string | null) => Promise<void>;
  placeOfDeliveryName: string | null;
}

const PlaceOfDeliveryNameDialog = ({ show, setShow, onSubmit, placeOfDeliveryName }: Props) => {
  // translations
  const tLabels = useTranslation("contracts\\contracts").t;
  const tTerms = useTranslation("shared\\terms").t;

  // form state
  const [deliveryName, setDeliveryName] = useState("");

  // set default name
  useEffect(() => {
    setDeliveryName(placeOfDeliveryName || "");
  }, [placeOfDeliveryName])

  // handlers
  const submitFormHandler = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(deliveryName);    
  }

  const removeNameHandler = () => {
    setDeliveryName("");
    onSubmit(null);    
  }

  // render
  return (
    <RolesChecker enabledRoles="Contributor">
      <Modal show={show} onHide={() => setShow(false)}>
        <ModalHeader title={tLabels("placeOfDeliveryNameDialog.cardTitle")} onCloseClick={() => setShow(false)} />
        <form onSubmit={submitFormHandler}>
          <div className="modal-body py-4">
            <div className="form-group">
              <label htmlFor="deliveryName">{tLabels("placeOfDeliveryNameDialog.deliveryName")}</label>
              <input
                  value={deliveryName}
                  onChange={(e) => setDeliveryName(e.target.value)}
                  type="text"
                  maxLength={50}
                  id="deliveryName"
                  className="form-control"
                  placeholder={tLabels("placeOfDeliveryNameDialog.setCustomDeliveryName")}
                />
            </div>
          </div>
          <ModalFooter>
            <button type="button" className="btn btn-outline-dark mr-2" onClick={removeNameHandler}>{tTerms("Delete")}</button>
            <button type="submit" className="btn btn-primary">{tLabels("placeOfDeliveryNameDialog.changeDeliveryName")}</button>
          </ModalFooter>
        </form>
        <PromiseLoadingSpinner area={ContractDetail_PlaceOfDeliveryNameDialog} />
      </Modal>
    </RolesChecker>
  );
}

export default PlaceOfDeliveryNameDialog;
